import namor from 'namor'

const range = len => {
  const arr = [];
  for (let i = 0; i < len; i++) {
    arr.push(i)
  }
  return arr
};

const newPerson = () => {
  const statusChance = Math.random();
  return {
    firstName: namor.generate({ words: 1, numbers: 0 }),
    lastName: namor.generate({ words: 1, numbers: 0 }),
    age: Math.floor(Math.random() * 30),
    visits: Math.floor(Math.random() * 100),
    progress: Math.floor(Math.random() * 100),
    status:
      statusChance > 0.66
        ? 'relationship'
        : statusChance > 0.33
        ? 'complicated'
        : 'single',
  }
};

export default function makeData(...lens) {
  // console.log('lens', lens);
  // log({lens});
  const makeDataLevel = (depth = 0) => {
    const len = lens[depth];
    // log({len});
    const rows = range(len).map(d => {
      const row = {
        ...newPerson(),
        subRows: lens[depth + 1] ? makeDataLevel(depth + 1) : undefined,
      };
      // if (d === 0) log({row});
      return row;
    });
    /*log({rows});
    console.log('rows[0]', rows[0]);*/
    return rows;
  };

  return makeDataLevel()
}
